export type ThemeMode = 'system' | 'light' | 'dark';

export function getThemeMode(): ThemeMode {
  const savedTheme = localStorage.getItem('theme');

  if (savedTheme === 'light' || savedTheme === 'dark') {
    return savedTheme;
  }

  return 'system';
}

export function setThemeMode(mode: ThemeMode) {
  if (mode === 'system') {
    localStorage.removeItem('theme');
  } else {
    localStorage.setItem('theme', mode);
  }
}

export function initTheme() {
  // Theme mode is applied by Astryx Theme in astryx-providers.tsx.
  getThemeMode();
}

/** @deprecated Use setThemeMode instead */
export function setTheme(theme: 'light' | 'dark') {
  setThemeMode(theme);
}

/** @deprecated Use getThemeMode instead */
export function getTheme() {
  const mode = getThemeMode();
  if (mode === 'system') {
    return null;
  }

  return mode;
}

/** @deprecated Use getThemeMode instead */
export function isDarkTheme() {
  return getThemeMode() === 'dark';
}
